import { Component, OnInit } from '@angular/core';
import { MenuService } from '@app/shared/services/menu.service';
import { ActivatedRoute } from '@angular/router';
import { SessionService } from '@app/shared/services/session.service';

@Component({
  selector: 'app-society-tab',
  templateUrl: './society-tab.component.html',
  styleUrls: ['./society-tab.component.scss']
})
export class SocietyTabComponent implements OnInit {
  
  public id;

  constructor(
    public menu: MenuService,
    public route: ActivatedRoute,
    public session: SessionService
  ) { }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
  }

}
